module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNDJhOWRmMTJmOGU3OWQ2MjViM2EyOTBlMjdiYjE4NzkucG5nIjs="